export const getCategoriesSelector = ({ blogsReducer: { categories = [] } = {} }) => categories;
export const getInterestsSelector = ({ blogsReducer: { interests = [] } = {} }) => interests;
export const getBlogs = ({ blogsReducer: { blogs = [] } = {} }) => blogs;
export const getBlogFilter = ({ blogsReducer: { filter = {} } = {} }) => filter;
export const getBlogsCount = ({ blogsReducer: { count = 0 } = {} }) => count;
export const getCommonFilter = ({ blogsReducer: { common_filter = {} } = {} }) => common_filter;
export const getCategoryFilter = ({ blogsReducer: { categoryFilter = {} } = {} }) => categoryFilter;
export const getUserFilter = ({ blogsReducer: { user_filter = {} } = {} }) => user_filter;
